<template>
  <div class="urgePage">
    <div class="riskHead">
      <h2>催办消息中心 <em :style="{ background: '#FF3B5C' }">URGE</em></h2>
      <p class="riskSub">被催办人在此查看催办信息并回复处理情况；审批提醒与审批结果也统一在这里查看，形成处置闭环</p>
    </div>

    <!-- 统计条 -->
    <div class="stripRow">
      <div class="stripCard" style="border-left:4px solid #FF3B5C">
        <div class="k">我收到的催办</div>
        <div class="v" style="color:#FF3B5C">{{ inbox.length }}<small>条</small></div>
        <div class="d">全部</div>
      </div>
      <div class="stripCard" style="border-left:4px solid #FF9F1C">
        <div class="k">待处理</div>
        <div class="v" style="color:#FF9F1C">{{ inboxPending }}<small>条</small></div>
        <div class="d">尚未查看 / 未回复</div>
      </div>
      <div class="stripCard" style="border-left:4px solid #00A576">
        <div class="k">已回复</div>
        <div class="v" style="color:#00A576">{{ inboxDone }}<small>条</small></div>
        <div class="d">处理闭环</div>
      </div>
      <div class="stripCard" style="border-left:4px solid #2E7BFF">
        <div class="k">我发起的催办</div>
        <div class="v" style="color:#2E7BFF">{{ sent.length }}<small>条</small></div>
        <div class="d">对外催办</div>
      </div>
    </div>

    <!-- 视角 + 状态筛选 -->
    <div class="riskCard">
      <div class="tabRow">
        <div class="dimTab" :class="{ active: tab === 'in' }" @click="tab = 'in'">
          📥 我收到的催办 <span class="cnt">{{ inbox.length }}</span>
        </div>
        <div class="dimTab" :class="{ active: tab === 'sent' }" @click="tab = 'sent'">
          📤 我发起的催办 <span class="cnt">{{ sent.length }}</span>
        </div>
        <div class="tabSpacer"></div>
        <div class="dimTab" :class="{ active: st === '' }" @click="st = ''">全部 <span class="cnt">{{ baseList.length }}</span></div>
        <div class="dimTab" :class="{ active: st === 'pending' }" @click="st = 'pending'">待处理 <span class="cnt">{{ basePending }}</span></div>
        <div class="dimTab" :class="{ active: st === 'done' }" @click="st = 'done'">已回复 <span class="cnt">{{ baseDone }}</span></div>
      </div>

      <!-- 消息卡片 -->
      <div class="msgList">
        <div v-for="m in showList" :key="m.view + m.urgeUserId" class="msgCard" :class="m.status">
          <div class="msgHead">
            <span class="msgTitle">{{ m.content }}</span>
            <span class="typeTag" :style="typeStyle(m.type)">{{ typeName(m.type) }}</span>
            <span class="typeTag" :style="statusStyle(m.status)">{{ statusName(m.status) }}</span>
          </div>
          <div class="msgMeta">
            <template v-if="m.view === 'in'">催办人：{{ m.fromUserName || '—' }}</template>
            <template v-else>被催办人：{{ m.toUserName || '—' }}</template>
            <template v-if="m.alertNo"> · 关联预警 <b>{{ m.alertNo }}</b></template>
            <template v-if="m.projectName"> · {{ m.projectName }}</template>
            <template v-if="m.domainName"> · {{ m.domainName }}</template>
            <template v-if="m.subType"> · {{ m.subType }}</template>
          </div>
          <div v-if="m.reply" class="msgReply"><b>回复：</b>{{ m.reply }}</div>
          <div class="msgFoot">
            <span class="msgTime">{{ (m.createTime || '').replace('T', ' ').slice(0, 16) }}</span>
            <div class="ops">
              <el-button v-if="m.view === 'in' && m.status === 'pending'" size="mini" @click="markRead(m)">标记已读</el-button>
              <el-button v-if="m.view === 'in' && m.status !== 'done' && m.type !== 'result'" size="mini" type="primary" @click="openReply(m)">回复处理情况</el-button>
              <el-button v-if="m.view === 'sent'" size="mini" @click="openAgain(m)">📣 再次催促 / 通知他人</el-button>
              <el-button v-if="m.alertId" size="mini" type="primary" plain @click="goAlert(m)">查看预警并跟进</el-button>
            </div>
          </div>
        </div>
        <div v-if="showList.length === 0" class="emptyBox">
          <div class="ico">📭</div>
          <p>暂无{{ tab === 'in' ? '收到的催办' : '发起的催办' }}</p>
        </div>
      </div>
    </div>

    <!-- 回复弹窗 -->
    <el-dialog title="回复处理情况" :visible.sync="replyVisible" width="34%">
      <div class="replyCtx" v-if="curMsg">{{ curMsg.content }}</div>
      <el-input type="textarea" :rows="4" v-model="replyText" placeholder="请填写处理情况回复（必填）"></el-input>
      <div slot="footer">
        <el-button size="small" @click="replyVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitReply">发送回复</el-button>
      </div>
    </el-dialog>

    <!-- 再次催促弹窗 -->
    <el-dialog title="再次催促 / 通知他人" :visible.sync="againVisible" width="34%">
      <div class="replyCtx" v-if="curMsg">对「{{ curMsg.content }}」再次催促；可发给原被催办人，也可通知其他人（系统内消息）</div>
      <el-select v-model="againForm.ToUserId" size="small" filterable allow-create default-first-option
        placeholder="催办对象 UserId" style="width:100%;margin-bottom:10px">
        <el-option v-if="curMsg" :value="curMsg.toUserId" :label="curMsg.toUserName + '（原被催办人）'"></el-option>
      </el-select>
      <el-input type="textarea" :rows="3" v-model="againForm.Content" placeholder="催办内容"></el-input>
      <div slot="footer">
        <el-button size="small" @click="againVisible = false">取消</el-button>
        <el-button size="small" type="primary" @click="submitAgain">发送催办</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";

export default {
  name: 'urgeCenter',
  data() {
    return {
      box: { inbox: [], sent: [] },
      tab: 'in',
      st: '',
      curMsg: null,
      replyVisible: false, replyText: '',
      againVisible: false, againForm: { AlertId: '', ToUserId: '', Content: '' }
    }
  },
  computed: {
    inbox() { return this.box.inbox || [] },
    sent() { return this.box.sent || [] },
    inboxPending() { return this.inbox.filter(x => x.status !== 'done').length },
    inboxDone() { return this.inbox.filter(x => x.status === 'done').length },
    baseList() { return this.tab === 'in' ? this.inbox : this.sent },
    basePending() { return this.baseList.filter(x => x.status !== 'done').length },
    baseDone() { return this.baseList.filter(x => x.status === 'done').length },
    showList() {
      return this.st === 'done' ? this.baseList.filter(x => x.status === 'done')
        : this.st === 'pending' ? this.baseList.filter(x => x.status !== 'done')
        : this.baseList
    }
  },
  mounted() { this.loadBox() },
  methods: {
    pick(o, k, d) { return o && o[k] !== undefined && o[k] !== null ? o[k] : d },
    async loadBox() {
      const r = await xz.EarlyWarnGet('GetRiskUrgeBox')
      if (!r || r.status !== 'ok' || !r.data) return
      this.box = { inbox: this.pick(r.data, 'inbox', []), sent: this.pick(r.data, 'sent', []) }
    },
    async markRead(m) {
      const r = await xz.EarlyWarnGet('ReadRiskUrge', { urgeUserId: m.urgeUserId })
      if (r && r.status === 'ok') this.loadBox()
    },
    openReply(m) { this.curMsg = m; this.replyText = ''; this.replyVisible = true },
    async submitReply() {
      if (!this.replyText.trim()) { this.$message('请填写回复内容'); return }
      const r = await xz.EarlyWarn({ UrgeUserId: this.curMsg.urgeUserId, Reply: this.replyText.trim() }, 'ReplyRiskUrge')
      this.$message(r && r.status === 'ok' ? (r.msg || '回复已发送') : (r && r.msg) || '发送失败')
      if (r && r.status === 'ok') { this.replyVisible = false; this.loadBox() }
    },
    openAgain(m) {
      this.curMsg = m
      this.againForm = { AlertId: m.alertId, ToUserId: m.toUserId, Content: '【再次催促】请尽快处理该预警：' + (m.projectName || '') }
      this.againVisible = true
    },
    async submitAgain() {
      if (!this.againForm.ToUserId) { this.$message('请选择催办对象'); return }
      const r = await xz.EarlyWarn(this.againForm, 'AddRiskUrge')
      this.$message(r && r.status === 'ok' ? '催办已发送' : (r && r.msg) || '发送失败')
      if (r && r.status === 'ok') { this.againVisible = false; this.loadBox() }
    },
    goAlert(m) {
      const map = { labor: '/laborCompliance', ar: '/arUncleared', payroll: '/payrollWarn', social: '/socialRateWarn' }
      this.$router.push(map[m.domain] || '/laborCompliance')
    },
    typeName(t) { return { urge: '催办', approve: '核销审批', result: '审批结果', urgeReply: '催办回复' }[t] || '催办' },
    typeStyle(t) {
      const c = { urge: '#2E7BFF', approve: '#7C5CFF', result: '#00A576', urgeReply: '#00C7E6' }[t] || '#2E7BFF'
      return { background: c + '1A', color: c, border: '1px solid ' + c }
    },
    statusName(s) { return { pending: '待处理', read: '已读待回复', done: '已回复' }[s] || s },
    statusStyle(s) {
      const c = { pending: '#FF3B5C', read: '#FF9F1C', done: '#00A576' }[s] || '#6B7392'
      return { background: c + '1A', color: c, border: '1px solid ' + c }
    }
  }
}
</script>

<style scoped>
.urgePage { padding: 20px 24px 60px; background: #F3F5FC; min-height: 100%; }
.riskHead h2 { font-size: 26px; font-weight: 800; color: #141A33; margin: 0 0 4px; display: flex; align-items: center; }
.riskHead h2 em { font-size: 12px; font-style: normal; color: #fff; border-radius: 6px; padding: 3px 8px; margin-left: 10px; }
.riskSub { font-size: 12.5px; color: #6B7392; margin: 0 0 14px; }
.stripRow { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; margin-bottom: 14px; }
.stripCard { background: #fff; border: 1px solid #E9EDF8; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 14px 16px; }
.stripCard .k { font-size: 13px; color: #6B7392; font-weight: 700; }
.stripCard .v { font-size: 32px; font-weight: 900; line-height: 1.2; letter-spacing: -1px; }
.stripCard .v small { font-size: 13px; font-weight: 700; margin-left: 3px; }
.stripCard .d { font-size: 12px; color: #6B7392; }
.riskCard { background: #fff; border: 1px solid #E9EDF8; border-radius: 12px; box-shadow: 0 3px 14px rgba(30,40,90,.06); padding: 16px 18px; }
.tabRow { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; padding-bottom: 12px; border-bottom: 1px solid #EEF1FA; margin-bottom: 14px; }
.tabSpacer { flex: 1; }
.dimTab { font-size: 13px; color: #6B7392; padding: 6px 14px; border-radius: 16px; cursor: pointer; border: 1px solid transparent; user-select: none; }
.dimTab:hover { background: #F3F5FC; color: #141A33; }
.dimTab.active { background: rgba(124,92,255,.12); border-color: rgba(124,92,255,.4); color: #7C5CFF; font-weight: 700; }
.dimTab .cnt { font-size: 11px; background: #F3F5FC; border-radius: 9px; padding: 1px 7px; margin-left: 4px; }
.dimTab.active .cnt { background: rgba(124,92,255,.18); }
.msgList { display: flex; flex-direction: column; gap: 12px; }
.msgCard { border: 1px solid #E9EDF8; border-radius: 10px; padding: 12px 14px; transition: .2s; }
.msgCard.pending { border-left: 4px solid #FF3B5C; background: #FFF8F9; }
.msgCard.read { border-left: 4px solid #FF9F1C; }
.msgCard.done { border-left: 4px solid #00A576; }
.msgHead { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.msgTitle { font-size: 14px; font-weight: 700; color: #141A33; flex: 1; min-width: 200px; }
.typeTag { font-size: 11px; padding: 2px 8px; border-radius: 10px; white-space: nowrap; }
.msgMeta { font-size: 12px; color: #6B7392; margin-top: 6px; }
.msgReply { font-size: 12.5px; color: #00695C; background: #EAF7F3; border-radius: 8px; padding: 8px 10px; margin-top: 8px; }
.msgFoot { display: flex; align-items: center; margin-top: 10px; }
.msgTime { font-size: 12px; color: #9AA1BC; }
.msgFoot .ops { margin-left: auto; display: flex; gap: 4px; }
.emptyBox { text-align: center; padding: 50px 0; color: #9AA1BC; }
.emptyBox .ico { font-size: 40px; }
.replyCtx { font-size: 12.5px; color: #2E5AAC; background: #EEF4FF; border-radius: 8px; padding: 8px 10px; margin-bottom: 10px; }
@media (max-width: 1100px) { .stripRow { grid-template-columns: repeat(2, 1fr); } }
</style>
